import { CssBaseline, ThemeProvider } from '@mui/material';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { store } from '@/domain/store';
import { FSConfirmDialogProvider } from '@/ui/components/confirm-dialog/FSConfirmDialogProvider';
import { EarlyFeatureReceiver } from '@/ui/components/early-feature/EarlyFeatureReceiver';
import { FSSnackbarProvider } from '@/ui/components/notification/FSSnackbarProvider';
import { router } from '@/ui/navigation/router';
import { theme } from '@/ui/theme';

export function Root() {
  dayjs.extend(isSameOrBefore);
  dayjs.extend(isSameOrAfter);

  return (
    <ThemeProvider theme={theme}>
      <FSConfirmDialogProvider>
        <CssBaseline />
        <FSSnackbarProvider />
        <ReduxProvider store={store}>
          <EarlyFeatureReceiver />
          <RouterProvider router={router} />
        </ReduxProvider>
      </FSConfirmDialogProvider>
    </ThemeProvider>
  );
}
